import styled from '@emotion/styled/macro';

export const ModalRoot = styled.div((_) => ({
  outline: 'none',
}));

export const PanelContent = styled.div((_) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: 16,
  maxWidth: 420,
  padding: '0 12px 10px 10px',
}));

export const Delimeter = styled.div((props) => ({
  borderBottom: `1px solid ${props.theme.colors.container.primary}`,
  width: '100%',
}));

export const Buttons = styled.div((_) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: 16,
}));
